export function copyTaskContent(task, otherTask) {
    task.skillSet = otherTask.skillSet
    task.title = otherTask.title
    task.content = otherTask.content
    task.note = otherTask.note
    task.minutes = otherTask.minutes
    task.unitOfMeasure = otherTask.unitOfMeasure
    task.frequency.period = otherTask.frequency.period
    task.frequency.interval = otherTask.frequency.interval
    task.classification = otherTask.classification
}
